import { Injectable } from '@angular/core';

/**
 * Remembers which chat session is open in this browser. The list of sessions itself lives on the
 * server (`AnalyticsCatalogService.listSessions`); localStorage only caches the current id.
 */
@Injectable({ providedIn: 'root' })
export class AnalyticsSessionStore {
  private key(userId: string): string {
    return `mcp-analytics-sessions:${userId || 'anon'}:current`;
  }

  currentId(userId: string): string | null {
    try {
      return localStorage.getItem(this.key(userId));
    } catch {
      return null;
    }
  }

  setCurrent(userId: string, sessionId: string): void {
    try {
      localStorage.setItem(this.key(userId), sessionId);
    } catch {
      // Storage may be unavailable (private mode); the session id still lives in memory.
    }
  }

  clearCurrent(userId: string): void {
    try {
      localStorage.removeItem(this.key(userId));
    } catch {
      // See setCurrent.
    }
  }

  /** The module tour auto-starts once per browser profile. A new scenario version uses a new key. */
  tourSeen(userId: string): boolean {
    try {
      return localStorage.getItem(this.tourKey(userId)) === '1';
    } catch {
      return true;
    }
  }

  markTourSeen(userId: string): void {
    try {
      localStorage.setItem(this.tourKey(userId), '1');
    } catch {
      // The tour can still be opened from the header.
    }
  }

  private tourKey(userId: string): string {
    return `reporting-analytics:tour:v1:${userId || 'anon'}`;
  }
}
